export default __webpack_public_path__ + "static/media/boi-mela2.339082d1.png";